<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header no-print">
              <div class="d-flex">
                <strong class="align-self-center">GAAU</strong>
                <strong class="align-self-center ml-auto mr-2"
                  >Acessar histórico do GAAU</strong
                >
                <GaauHistory :gaauId="viewModel.id"></GaauHistory>
              </div>
            </header>
            <div class="card-body">
              <div class="row no-print">
                <div class="col">
                  <div class="form-group">
                    <small>Campos com * são de preenchimento obrigatório</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>* Projeto</label>
                    <input
                      v-if="isEdit"
                      readonly
                      v-model="project.name"
                      class="form-control"
                    />
                    <v-select
                      v-else
                      placeholder="Digite o nome do projeto"
                      v-model="project"
                      :options="projects"
                      v-on:input="OnChangeProject"
                      readonly
                      required
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>* Data </label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.date"
                      class="form-control"
                      type="date"
                      placeholder="Digite a data"
                      required
                    />
                  </div>
                </div>
                <div
                  class="col-sm-12 col-md-1 col-lg-1 col-xl-1"
                  v-if="version"
                >
                  <div class="form-group">
                    <label for>Versão: </label>
                    <input
                      :disabled="true"
                      v-model="version"
                      class="form-control"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <GoogleMaps
                :disableEdit="disableEdit"
                setLocalEmit="set-location"
                @set-location="SetLocation"
                :markers="markers"
              />
              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Id</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.sequence"
                      class="form-control"
                      type="number"
                      placeholder="Digite o id"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Nome Comum</label>

                    <v-select
                      :disabled="disableEdit"
                      taggable
                      placeholder="Digite o nome comum"
                      label="commonName"
                      v-model="viewModel.commonName"
                      :reduce="(option) => option.commonName"
                      :options="carbons"
                      v-on:input="OnChangeCommonName"
                      :create-option="item => ({ id: '', commonName: item })"
                      required
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>

                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Nome Científico</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.scientificName"
                      class="form-control"
                      type="text"
                      placeholder="Digite o nome científico"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Origem</label>
                    <b-form-radio
                      :disabled="disableEdit"
                      v-model="viewModel.origin"
                      name="origin-radio"
                      value="Nativa"
                      >Nativa</b-form-radio
                    >
                    <b-form-radio
                      :disabled="disableEdit"
                      v-model="viewModel.origin"
                      name="origin-radio"
                      value="Exótica"
                      >Exótica</b-form-radio
                    >
                    <b-form-radio
                      :disabled="disableEdit"
                      v-model="viewModel.origin"
                      name="origin-radio"
                      value="Exótica Invasora"
                      >Exótica Invasora</b-form-radio
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>Situação</label>
                    <b-form-radio
                      :disabled="disableEdit"
                      @change="OnChangePoint(0, 0)"
                      v-model="viewModel.status"
                      name="status-radio"
                      value="Plantio"
                      >Plantio</b-form-radio
                    >
                    <b-form-radio
                      :disabled="disableEdit"
                      @change="OnChangePoint(0, 0)"
                      v-model="viewModel.status"
                      name="status-radio"
                      value="Viva"
                      >Viva</b-form-radio
                    >
                    <b-form-radio
                      :disabled="disableEdit"
                      @change="OnChangePoint(0, 999)"
                      v-model="viewModel.status"
                      name="status-radio"
                      value="Morta"
                      >Morta</b-form-radio
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Família</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.family"
                      class="form-control"
                      type="text"
                      placeholder="Digite a família"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Altura total (Ht) m</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.heigth"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite a altura"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Classe de altura observado a campo</label>
                    <b-form-radio
                      :disabled="disableEdit"
                      v-model="viewModel.heigthClass"
                      name="heigthClass-radio"
                      value="Pequeno (< 6m)"
                      >Pequeno (< 6m)</b-form-radio
                    >
                    <b-form-radio
                      :disabled="disableEdit"
                      v-model="viewModel.heigthClass"
                      name="heigthClass-radio"
                      value="Médio (6 a 12m)"
                      >Médio (6 a 12m)</b-form-radio
                    >
                    <b-form-radio
                      :disabled="disableEdit"
                      v-model="viewModel.heigthClass"
                      name="heigthClass-radio"
                      value="Grande (> 12m)"
                      >Grande (> 12m)</b-form-radio
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>CAP (cm)</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.cap"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite o CAP"
                      @change="OnChangeCap"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>DAP (cm)</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.dap"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite o DAP"
                      @change="OnChangeDap"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Altura da Primeira Bifurcação (m)</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.fisrtHeigth"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite a altura"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>R1 (N)</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.radiusOne"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite raio da copa"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>R2 (L)</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.radiusTwo"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite raio da copa"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>R3 (S)</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.radiusThree"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite raio da copa"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>R4 (O)</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.radiusFour"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite raio da copa"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div
                  class="mt-3 col-sm-12 col-md-3 col-lg-3 col-xl-3"
                  :key="indexQuestion"
                  v-for="(question, indexQuestion) in questions"
                >
                  <div class="">
                    <label for>{{ question.description }}</label>
                  </div>
                  <b-form-radio
                    :disabled="disableEdit"
                    :key="indexAnswer"
                    v-for="(answer, indexAnswer) in question.answers"
                    @change="OnChangePoint(question.index, answer.point)"
                    v-model="models[question.index]"
                    :name="answer.code"
                    :value="answer.description"
                    >{{ answer.description }}</b-form-radio
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>Resultado do Índice GAAU </label>
                    <h4><span :class="ResultColor(viewModel.result)">{{ ResultName(viewModel.result) }}</span></h4>
                  </div>
                </div>
                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>Carbono (kg)</label>
                    <input
                      :disabled="disableEdit"
                      v-model="viewModel.carbon"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite o Carbono"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <b-form-group
                    label="RECOMENDAÇÃO DE MANEJO"
                    v-slot="{ ariaDescribedby }"
                  >
                    <b-form-checkbox
                      :disabled="disableEdit"
                      v-for="(option, index) in managers"
                      v-model="viewModel.managers[index]"
                      :key="option"
                      :value="option"
                      :aria-describedby="ariaDescribedby"
                      inline
                    >
                      {{ option }}
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="">Observações</label>
                    <b-form-textarea
                      :disabled="disableEdit"
                      v-model="viewModel.obs"
                      rows="4"
                      max-rows="12"
                      placeholder="Digite observações"
                    ></b-form-textarea>
                  </div>
                </div>
              </div>
              <div class="row no-print">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for>Imagens </label> <small>Limite 20MB</small>
                    <b-form-file
                      v-model="files"
                      :state="Boolean(files)"
                      placeholder="Escolha o(s) arquivo(s)..."
                      accept=".jpg, .png, .jpeg"
                      browse-text="Procurar"
                      multiple
                    ></b-form-file>
                  </div>
                </div>
              </div>
              <GalleryImage
                removeEmit="remove-file"
                @remove-file="RemoveFile"
                :images="images"
              />
            </div>

            <div class="btn-toolbar mb-3 ml-3 no-print" role="toolbar">
              <div v-if="showButtonSave">
                <div class="btn-group" role="group">
                  <button
                    class="btn btn-success mr-2"
                    type="submit"
                    title="Salva os dados do GAAU"
                  >
                    Salvar
                  </button>
                </div>
                <div class="btn-group" role="group">
                  <SaveHistoryGaauButton :action="SaveHistory" />
                </div>
                <div v-if="isEdit" class="btn-group" role="group">
                  <RemoveGaauButton
                    v-permission="'Gaau.Remover'"
                    :gaauId="viewModel.id"
                    :version="version"
                  />
                </div>
              </div>

              <div v-if="disableEdit" class="btn-group" role="group">
                <input
                  class="btn btn-success mr-2"
                  type="button"
                  @click="Edit"
                  value="Editar"
                />
              </div>

              <div class="btn-group" role="group">
                <b-button variant="outline-dark" @click="Print"
                  >Imprimir</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import GaauService from "../../servico/GaauService";
import DateTime from "../../util/DateTime";
import GoogleMaps from "../../components/GoogleMaps";
import ProjectService from "../../servico/ProjectService";
import FileService from "../../servico/ArquivoServico";
import GalleryImage from "../../components/GalleryImage.vue";
import QuestionService from "../../servico/QuestionService";
import PermissionService from "../../servico/PermissionService";
import PermissionEnum from "../../enums/PermissionEnum";
import GaauManagersEnum from "../../enums/GaauManagersEnum";
import GaauManagerService from "../../servico/GaauManagerService";
import GaauHistory from "./GaauHistory.vue";
import RemoveGaauButton from "./RemoveGaauButton.vue";
import SaveHistoryGaauButton from "./SaveHistoryGaauButton.vue";
import CarbonService from "../../servico/CarbonService";

export default {
  name: "NewGaau",
  components: {
    RotateSquare,
    GoogleMaps,
    GalleryImage,
    GaauManagersEnum,
    GaauHistory,
    RemoveGaauButton,
    SaveHistoryGaauButton
  },
  data() {
    return {
      isEdit: false,
      loading: false,
      projects: [],
      carbons: [],
      files: null,
      images: null,
      project: {},
      markers: [],
      questions: [],
      models: [],
      managers: [],
      disableEdit: false,
      showButtonSave: false,
      version: null,
      viewModel: {
        id: this.$store.getters.emptyGuid,
        projectId: null,
        date: DateTime.Now(),
        dap: null,
        cap: null,
        obs: "",
        heigthClass: "",
        heigth: "",
        family: "",
        origin: "",
        scientificName: "",
        commonName: "",
        latitude: null,
        longitude: null,
        sequence: 0,
        files: [],
        fisrtHeigth: "",
        radiusOne: 0,
        radiusTwo: 0,
        radiusThree: 0,
        radiusFour: 0,
        branchesInterfering: "",
        branchesEchoes: "",
        birdWeed: "",
        balancedCup: "",
        anchorCabling: "",
        cavity: "",
        figTreeKillsWood: "",
        termite: "",
        leafCuttingAnt: "",
        snailDrills: "",
        fungus: "",
        nutritionalDeficiency: "",
        trunkTilt: "",
        epicormicShoots: "",
        freeArea: "",
        buriedLap: "",
        compactedSoil: "",
        pedestrianCirculation: "",
        circulationVehicles: "",
        points: [],
        status: "",
        sidewalkSurvey: "",
        managers: []
      }
    };
  },
  mounted() {
    let id = this.$route.params.id;
    this.version = this.$route.params.version;
    this.GetQuestions();
    for (let index = 0; index < 20; index++) {
      this.models[index] = "";
    }
    if (id && id !== this.$store.getters.emptyGuid) {
      this.isEdit = true;
      this.disableEdit = true;
      this.showButtonSave = false;
      this.Get(id, this.version);
      this.GetFiles(id);
    } else {
      this.showButtonSave = PermissionService.isValid(
        PermissionEnum.Gaau.Adicionar
      );
    }
    if (!this.isEdit) {
      for (let index = 0; index < 20; index++) {
        this.viewModel.points[index] = 0;
      }
    }

    this.OnSearchProjects("    ");
    this.GetAllCarbons();
    this.managers = GaauManagersEnum;
  },
  methods: {
    Print() {
      window.print();
    },
    OnChangePoint(index, point) {
      this.viewModel.points[index] = point;
    },

    OnChangeProject(a) {
      if (this.isEdit) return;
      if (!this.project) return;

      ProjectService.GetCoordinates(this.project.id)
        .then((result) => {
          this.markers = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      ProjectService.GetNextSequence(this.project.id)
        .then((result) => {
          this.viewModel.sequence = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    OnChangeCap() {
      this.viewModel.dap = (this.viewModel.cap / 3.14).toFixed(2);
      this.CalcCarbon();
    },
    OnChangeDap() {
      this.viewModel.cap = (this.viewModel.dap * 3.14).toFixed(2);
      this.CalcCarbon();
    },
    ValidarForm(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (!PermissionService.isValid(PermissionEnum.Gaau.Editar)) {
          PermissionService.showMessage();
          return;
        }
      } else {
        if (!PermissionService.isValid(PermissionEnum.Gaau.Adicionar)) {
          PermissionService.showMessage();
          return;
        }
      }

      this.Save();
    },
    OnSearchProjects(term) {
      if (!term || term.length <= 2) return;

      ProjectService.GetVSelect(term, true)
        .then((result) => {
          this.projects = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    RemoveFile(item) {
      if (
        !PermissionService.isValidAndShowMessage(
          PermissionEnum.Gaau.ImagemRemover
        )
      )
        return;

      GaauService.RemoveFile(item.id, this.viewModel.id)
        .then((resposta) => {
          this.loading = false;
          this.images.splice(this.images.indexOf(item), 1);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Get(id, version) {
      this.loading = true;

      GaauService.Get(id, version)
        .then((resposta) => {
          this.loading = false;
          this.viewModel = resposta.data;
          this.viewModel.date = DateTime.Format(resposta.data.date);
          this.viewModel.managers = GaauManagerService.Mounted(
            resposta.data.managers
          );
          this.markers.push({
            lat: this.viewModel.latitude,
            lng: this.viewModel.longitude,
            label: "NOVO - " + this.viewModel.status,
            new: true,
            result: this.viewModel.result
          });
          this.GetProject(this.viewModel.projectId);
          this.MountedEditViewModel();
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetProject(id) {
      ProjectService.Get(id)
        .then((resposta) => {
          this.project = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetFiles(inventoryId) {
      GaauService.GetFiles(inventoryId, this.version)
        .then((resposta) => {
          this.images = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    UploadFiles() {
      this.loading = true;
      FileService.New(this.files)
        .then((response) => {
          this.loading = false;
          this.viewModel.files = response.data;
          if (this.isEdit) this.SaveEdit();
          else this.SaveNew();
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    async SaveEdit() {
      this.loading = true;
      await this.MountedViewModel();

      GaauService.Edit(this.viewModel)
        .then(() => {
          this.disableEdit = true;
          this.showButtonSave = false;
          this.loading = false;
          this.$router.go(-1);
          this.$notify({
            data: ["GAAU editado com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    async SaveNew() {
      this.loading = true;
      await this.MountedViewModel();
      GaauService.New(this.viewModel)
        .then(() => {
          this.disableEdit = true;
          this.showButtonSave = false;
          this.loading = false;
          this.$router.go(-1);
          this.$notify({
            data: ["GAAU cadastrado com sucesso."],
            type: "success",
            duration: 5000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },

    ValidateCoordenate() {
      return !this.viewModel.latitude && !this.viewModel.longitude;
    },
    Save() {
      this.viewModel.projectId = this.project.id;

      if (this.ValidateCoordenate()) {
        this.$notify({
          data: ["Informe latitude e longitude no mapa."],
          type: "warn",
          duration: 5000
        });
        return;
      }

      if (this.files) {
        this.UploadFiles();
      } else if (this.isEdit) {
        this.SaveEdit();
      } else {
        this.SaveNew();
      }
    },
    SetLocation(latitude, longitude) {
      this.viewModel.latitude = latitude;
      this.viewModel.longitude = longitude;
    },
    GetQuestions() {
      QuestionService.GetAll()
        .then((resposta) => {
          this.questions = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    async SaveHistory(date) {
      if (!PermissionService.isValid(PermissionEnum.Gaau.AdicionarHistorico)) {
        PermissionService.showMessage();
        return;
      }
      this.loading = true;
      this.viewModel.date = date || this.viewModel.date;
      GaauService.NewHistory(this.viewModel.id)
        .then(() => {
          this.loading = false;
          this.Save();
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Edit() {
      if (this.version > 0) {
        PermissionService.showMessage(
          "Você não pode editar uma versão de um histórico do GAAU."
        );
        return;
      }

      this.disableEdit = !PermissionService.isValidAndShowMessage(
        PermissionEnum.Gaau.Editar
      );

      this.showButtonSave = !this.disableEdit;
    },
    GetAllCarbons() {
      CarbonService.GetAll()
        .then((response) => {
          this.carbons = response.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    CalcCarbon() {
      let carbon = this.carbons.find((carbon) => carbon.commonName == this.viewModel.commonName);

      if (!carbon || !carbon.density || !this.viewModel.dap || !this.viewModel.heigth)
        return;

        let dap = parseFloat(this.viewModel.dap);
        let heigth = parseFloat(this.viewModel.heigth);


      this.viewModel.carbon = (0.0673 * Math.pow((carbon.density * Math.pow(dap,2) * heigth), 0.976)).toFixed(2);
    },
    OnChangeCommonName(item) {
      if (!item) return;

      let carbon = this.carbons.find((carbon) => carbon.commonName == item);
      if (!carbon)
      return

      this.viewModel.scientificName = carbon.scientificName;
      this.CalcCarbon();
    },
    async MountedViewModel() {
      for (let i = 0; i < this.models.length; i++) {
        const element = this.models[i];
        switch (i) {
          case 1:
            this.viewModel.branchesInterfering = element;
            break;
          case 2:
            this.viewModel.branchesEchoes = element;
            break;
          case 3:
            this.viewModel.birdWeed = element;
            break;
          case 4:
            this.viewModel.balancedCup = element;
            break;
          case 5:
            this.viewModel.anchorCabling = element;
            break;
          case 6:
            this.viewModel.cavity = element;
            break;
          case 7:
            this.viewModel.figTreeKillsWood = element;
            break;
          case 8:
            this.viewModel.termite = element;
            break;
          case 9:
            this.viewModel.leafCuttingAnt = element;
            break;
          case 10:
            this.viewModel.snailDrills = element;
            break;
          case 11:
            this.viewModel.fungus = element;
            break;
          case 12:
            this.viewModel.nutritionalDeficiency = element;
            break;
          case 13:
            this.viewModel.trunkTilt = element;
            break;
          case 14:
            this.viewModel.epicormicShoots = element;
            break;
          case 15:
            this.viewModel.freeArea = element;
            break;
          case 16:
            this.viewModel.buriedLap = element;
            break;
          case 17:
            this.viewModel.sidewalkSurvey = element;
            break;
          case 18:
            this.viewModel.pedestrianCirculation = element;
            break;
          case 19:
            this.viewModel.circulationVehicles = element;
            break;
          case 0:
          default:
            break;
        }
      }
    },
    MountedEditViewModel() {
      for (let i = 0; i < this.models.length; i++) {
        switch (i) {
          case 1:
            this.models[i] = this.viewModel.branchesInterfering;
            break;
          case 2:
            this.models[i] = this.viewModel.branchesEchoes;
            break;
          case 3:
            this.models[i] = this.viewModel.birdWeed;
            break;
          case 4:
            this.models[i] = this.viewModel.balancedCup;
            break;
          case 5:
            this.models[i] = this.viewModel.anchorCabling;
            break;
          case 6:
            this.models[i] = this.viewModel.cavity;
            break;
          case 7:
            this.models[i] = this.viewModel.figTreeKillsWood;
            break;
          case 8:
            this.models[i] = this.viewModel.termite;
            break;
          case 9:
            this.models[i] = this.viewModel.leafCuttingAnt;
            break;
          case 10:
            this.models[i] = this.viewModel.snailDrills;
            break;
          case 11:
            this.models[i] = this.viewModel.fungus;
            break;
          case 12:
            this.models[i] = this.viewModel.nutritionalDeficiency;
            break;
          case 13:
            this.models[i] = this.viewModel.trunkTilt;
            break;
          case 14:
            this.models[i] = this.viewModel.epicormicShoots;
            break;
          case 15:
            this.models[i] = this.viewModel.freeArea;
            break;
          case 16:
            this.models[i] = this.viewModel.buriedLap;
            break;
          case 17:
            this.models[i] = this.viewModel.sidewalkSurvey;
            break;
          case 18:
            this.models[i] = this.viewModel.pedestrianCirculation;
            break;
          case 19:
            this.models[i] = this.viewModel.circulationVehicles;
            break;
          case 0:
          default:
            break;
        }
      }
    },
    ResultName(result) {
      return GaauService.ResultName(result);
    },
    ResultColor(result) {
      return GaauService.ResultColor(result);

    }
  }
};
</script>
